module.exports = __webpack_public_path__ + "img/9a_asia.c5a47b59.png";